export default __webpack_public_path__ + "media/components/InstructionButton/images/rule2-c8a683db312dc0e01e9e5001a6be4507.png";